<!-- 考点信息管理 -->
<template>
  <div class="registrationManagement">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入考点名称"
          style="width: 200px"
          @keyup.enter.native="frechLoad"
          @clear="
            query.query = '';
            frechLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button
            style="margin: 0px 10px"
            size="small"
            @click="
              query.pageNum = 1;
              frechLoad();
            "
            >查询</el-button
          >
        </Debounce>
        <el-select v-model="query.provinceId" @change="frechLoad" filterable placeholder="请选择">
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.examSite" filterable placeholder="请选择" @change="frechLoad()">
          <el-option label="全部市代" value=""></el-option>
          <el-option
            v-for="item in examSiteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-button type="primary" size="small" @click="operatInfo(1)" v-if="$roleFilter('exam:add')"
        >添加</el-button
      >
      <el-button type="primary" size="small" @click="addManager" v-if="$roleFilter('exam:addUser')"
        >添加管理员</el-button
      >
      <Debounce>
        <el-button
          style="margin-left: 10px"
          type="primary"
          size="small"
          @click="operatInfo(4)"
          :loading="exportTicketLoading"
          v-if="$roleFilter('exam:export:code')"
          >导出二维码
        </el-button>
      </Debounce>
      <FileOperatDropdown
        @reLoad="tableLoad"
        style="margin: 0px 10px"
        :roles="[
          $roleFilter('exam:download'),
          $roleFilter('exam:import'),
          $roleFilter('exam:export'),
        ]"
        :uploadUrl="'assigns/import'"
        :downloadUrl="'assigns/download'"
        :exportUrl="'/assigns/export'"
        :exportData="query"
        :butText="['下载模板', '导入考点', '导出考点']"
      />
      <el-button type="danger" size="small" @click="operatInfo(0)" v-if="$roleFilter('exam:delete')"
        >删除</el-button
      >
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      @selection-change="handleSelectionChange"
      :height="$store.getters.getTableHeight"
    >
      <el-table-column type="selection" align="center" width="50"></el-table-column>
      <el-table-column
        prop="registrationPointName"
        label="考点名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="provinceName" label="所属省份" align="center"></el-table-column>
      <el-table-column prop="examSiteName" label="所属市级代理" align="center"></el-table-column>
      <!-- <el-table-column
        prop="region"
        show-overflow-tooltip
        label="所属区域"
        align="center"
      ></el-table-column> -->
      <el-table-column width="140" label="是否允许线上缴费" align="center">
        <template slot-scope="scope">
          {{ scope.row.onlinePayment == 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column width="140" label="是否允许线下缴费" align="center">
        <template slot-scope="scope">
          {{ scope.row.offlinePayment == 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        show-overflow-tooltip
        label="考点管理员"
        align="center"
      ></el-table-column>
      <el-table-column prop="mobile" label="联系电话" width="120" align="center"></el-table-column>
      <el-table-column
        prop="registrationAddress"
        show-overflow-tooltip
        label="地址"
        align="center"
      ></el-table-column>
      <el-table-column label="考点二维码" width="120" align="center">
        <template slot-scope="scope">
          <Debounce>
            <el-button
              :disabled="scope.row.state === 0"
              type="text"
              @click="operatInfo(3, scope.row)"
              >考点二维码</el-button
            >
          </Debounce>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="tableContentUpdateBut"
            @click="operatInfo(2, scope.row)"
            v-if="$roleFilter('exam:update')"
            >修改
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        width="120px"
        align="center"
        v-if="
          tableList && tableList.length > 0 && (tableList[0].zybm == 0 || tableList[0].zybm == 1)
        "
      >
        <template slot-scope="scope">
          <div class="tableSwitch">
            <el-switch
              v-model="scope.row.state"
              :disabled="!$roleFilter('exam:enable')"
              class="switch"
              @change="releaseSwitch(scope.row)"
              active-color="#409eff"
              active-text="启用"
              :active-value="1"
              inactive-color="#c0c4cc"
              inactive-text="禁用"
              :inactive-value="0"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="是否开放自由报名"
        width="120px"
        align="center"
        v-if="
          tableList && tableList.length > 0 && (tableList[0].zybm == 0 || tableList[0].zybm == 1)
        "
      >
        <template slot-scope="scope">
          <div class="tableSwitch">
            <el-switch
              v-model="scope.row.zybm"
              class="switch"
              @change="releaseSwitch1(scope.row)"
              active-color="#409eff"
              active-text="是"
              :active-value="1"
              inactive-color="#c0c4cc"
              inactive-text="否"
              :inactive-value="0"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      class="pagination-content"
      @pagination="tableLoad"
    />
    <el-dialog
      custom-class="dailogComponents"
      :title="visibleType == 1 ? '添加' : visibleType == 3 ? '考点二维码' : '修改'"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="14">
            <p><span style="color: red">*</span>考点名称:</p>
          </el-col>
          <el-col :offset="1">
            <el-input
              v-model="visibleObj.registrationPointName"
              placeholder="请输入内容"
              :maxlength="100"
              @input="handleInput"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="14">
            <p><span style="color: red">*</span>所属市级代理:</p>
          </el-col>
          <el-col :offset="1">
            <el-select
              v-model="visibleObj.examSiteId"
              style="width: 100%"
              filterable
              placeholder="请选择"
              @change="getDivisionList"
            >
              <el-option
                v-for="item in examinationList"
                :key="item.id"
                :label="item.examSiteName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- <el-row
          type="flex"
          v-if="divisionList.length != 0"
          class="dialogTitle"
          justify="space-between"
        >
          <el-col :span="14">
            <p><span style="color: red">*</span>所属区域:</p>
          </el-col>
          <el-col :offset="1">
            <el-select
              v-model="visibleObj.region"
              style="width: 100%"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in divisionList"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row> -->
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="14">
            <p><span style="color: red">*</span>是否允许线上缴费:</p>
          </el-col>
          <el-col :offset="1">
            <el-radio-group v-model="visibleObj.onlinePayment">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="14">
            <p><span style="color: red">*</span>是否允许线下缴费:</p>
          </el-col>
          <el-col :offset="1">
            <el-radio-group v-model="visibleObj.offlinePayment">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="14">
            <p><span style="color: red">*</span>考点管理员:</p>
          </el-col>
          <el-col :offset="1">
            <el-select
              v-model="visibleObj.registrationPoint"
              filterable
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.name"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="14">
            <p><span style="color: red">*</span>省市区:</p>
          </el-col>
          <el-col :offset="1">
            <el-cascader
              :options="nativeList"
              v-model="addressList"
              filterable
              :props="{
                checkStrictly: true,
              }"
              clearable
              @change="handleCascaderChange"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="14">
            <p><span style="color: red">*</span>地址:</p>
          </el-col>
          <el-col :offset="1">
            <el-input
              v-model="visibleObj.registrationAddress"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-button size="medium" @click="visible = false">取消</el-button>
          <Debounce>
            <el-button size="medium" type="primary" @click="submit">确认</el-button>
          </Debounce>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      custom-class="dailogComponents"
      :visible.sync="visible2"
      title="考点二维码"
      center
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="400px"
    >
      <img style="width: 400px" :src="QRCodePath" alt="" />
    </el-dialog>
    <el-dialog
      custom-class="dailogComponents"
      title="添加管理员"
      :visible.sync="visible1"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>用户名:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj1.userName" placeholder="请输入" maxlength="50"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>姓名:</p>
          </el-col>
          <el-col :offset="1">
            <el-input
              v-model="visibleObj1.name"
              placeholder="请输入内容"
              maxlength="100"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>性别:</p>
          </el-col>
          <el-col :offset="1">
            <el-radio-group v-model="visibleObj1.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p>证件号码:</p>
          </el-col>
          <el-col :offset="1">
            <el-input
              v-model="visibleObj1.idNumber"
              placeholder="请输入内容"
              maxlength="18"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p>所属角色:</p>
          </el-col>
          <el-col :offset="1">
            <p style="text-align: left; padding-left: 10px">{{ '考点管理员' }}</p>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>联系电话:</p>
          </el-col>
          <el-col :offset="1">
            <el-input
              v-model="visibleObj1.mobile"
              placeholder="请输入10-15位数字的手机号！"
              maxlength="15"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <div class="tip">温馨提醒：新加的考点管理员的初始密码为联系电话</div>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible1 = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="primary" @click="submit1">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileOperatDropdown from '@/views/admin/components/FileOperatDropdown';
import { exportFile } from '@/uitls/globalFun.js';

export default {
  components: {
    FileOperatDropdown,
  },
  data() {
    return {
      tableList: [],
      tableIsLoad: true,
      exportTicketLoading: false, //导出

      tableSelectList: [],
      userList: [],
      examinationList: [],
      divisionList: [],
      QRCodePath: '',
      roleList: [],
      visible: false,
      visible1: false,
      visible2: false,
      visibleType: 0, //删除
      visibleObj: {
        examSiteId: '', //所属市级代理
        onlinePayment: 0, //是否允许线上缴费
        offlinePayment: 0, //是否允许线下缴费
        // region: '', //所属区域
        registrationAddress: '', //地址
        registrationPoint: '', //考点管理员
        registrationPointName: '', //考点名称
        district: '', //区
        city: '', //市
        province: '',
      },
      nativeList: [],
      addressList: [],
      visibleObj1: {},
      query: {
        query: '',
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        examSite: '', //考点id
        provinceId: '', //全部省份
      },
      proList: [], //省份下拉框
      examSiteList: [], //考点下拉框
    };
  },
  mounted() {
    this.getAllUser();
    this.tableLoad();
    this.getNtiveList();
  },
  methods: {
    handleCascaderChange(value) {
      console.log('value', value);
      // 初始化省、市、区为默认值
      this.visibleObj.province = '';
      this.visibleObj.city = '';
      this.visibleObj.district = '';

      // 根据 value 的长度设置相应的值
      if (value.length > 0) {
        this.visibleObj.province = +value[0]; // 省
      }
      if (value.length > 1) {
        this.visibleObj.city = +value[1]; // 市
      }
      if (value.length > 2) {
        this.visibleObj.district = +value[2]; // 区
      }
    },
    frechLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    addManager() {
      this.visibleObj1 = {
        mobile: '', //手机号
        name: '', //姓名
        sex: 1, //性别
        userName: '', //用户名
        idNumber: null, //身份证号
      };
      this.visible1 = true;
    },
    getNtiveList() {
      //省市区
      this.$axios.get('/assigns/tree/province').then((res) => {
        let arr = res.data.data;
        if (arr) {
          this.nativeList = arr.map((item) => {
            return {
              ...item,
              children: item.children.map((el) => {
                return {
                  ...el,
                  children: el.children.length
                    ? el.children.map((e) => {
                        delete e.children;
                        return {
                          ...e,
                        };
                      })
                    : '',
                };
              }),
            };
          });
        }
      });
    },
    releaseSwitch(row) {
      row.state = row.state == 0 ? 1 : 0;
      let subPath = '/assigns/changeState?id=' + row.id;
      this.$dailog({
        title: row.state === 0 ? '启用' : '禁用',
        context: row.state === 0 ? '是否确认启用？' : '是否确认禁用？',
        htmlContext:
          row.state === 0 ? '启用后请及时关联考点管理员。' : '禁用后，考生将不可选到此考点。',
        callbackFun: () => {
          this.$axios.post(subPath).then((res) => {
            this.$message({
              type: 'success',
              message: '操作成功!',
              duration: 1000,
            });
            this.tableLoad();
          });
        },
      });
    },
    releaseSwitch1(row) {
      console.log(row);
      this.$axios.put(`/assigns/${row.id}/${row.zybm}`).then((res) => {
        this.$message({
          type: 'success',
          message: '操作成功!',
        });
        this.tableLoad();
      });
      // this.times = []
    },
    //省份下拉框变更事件
    provinceChange(val) {
      // this.query.examSite = "";
      // if (val == "") {
      //   this.examSiteList = [];
      // } else {
      //   let proObj = this.proList.find((item) => {
      //     return item.provinceId === val;
      //   });
      //   this.examSiteList = proObj.examSiteVOS;
      // }
      this.tableLoad();
    },
    tableLoad() {
      this.$axios.post('/assigns/list', this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    getAllUser() {
      this.$axios.get('/examination/site/select').then((res) => {
        this.examinationList = res.data.data;
      });
      this.$axios.get('/assigns/newProvince').then((res) => {
        this.proList = res.data.data;
      });
      this.$axios.get('/assigns/examinationSite').then((res) => {
        this.examSiteList = res.data.data;
      });
      this.$axios.get('/user/assigns/select').then((res) => {
        this.userList = res.data.data;
      });
    },
    operatInfo(type, row) {
      this.visibleType = type;
      this.visibleObj = {
        examSiteId: '', //所属市级代理
        onlinePayment: 0, //是否允许线上缴费
        offlinePayment: 0, //是否允许线下缴费
        // region: '', //所属区域
        registrationAddress: '', //地址
        registrationPoint: '', //考点管理员
        registrationPointName: '', //考点名称
        district: '', //区
        city: '', //市
        province: '',
      };
      if (type === 0) {
        //删除
        if (this.tableSelectList.length == 0) {
          this.$message({
            type: 'warning',
            message: '请选择数据进行操作!',
            duration: 1000,
          });
          return;
        }
        let isSub = true;
        let submitIdList = this.tableSelectList.map((item) => {
          if (item.linkStu != 0) {
            isSub = false;
          }
          return item.id;
        });
        let context = isSub
          ? '是否删除所选数据？'
          : '所选考点已有考生信息，删除后考生的报名信息和考试信息无法恢复，是否继续删除？';
        this.$dailog({
          title: '删除',
          context,
          callbackFun: () => {
            this.$axios
              .delete('/assigns', {
                data: submitIdList,
              })
              .then((res) => {
                this.$message({
                  type: 'success',
                  message: '操作成功!',
                  duration: 1000,
                });
                this.tableLoad();
              });
          },
        });
      } else if (type === 1) {
        //添加
        this.visible = true;
      } else if (type == 2) {
        //修改
        this.visible = true;
        this.visibleObj = JSON.parse(JSON.stringify(row));
        console.log('this.visibleObj', this.visibleObj);
        this.addressList = [
          this.visibleObj.province,
          this.visibleObj.city,
          this.visibleObj.district,
        ]
          .map((item) => (item !== null ? String(item) : null)) // 转换为字符串，null 保留为 null
          .filter(Boolean); // 过滤掉所有 falsy 值
        console.log('this.addressList', this.addressList);
      } else if (type == 3) {
        this.$axios.get('/assigns/code/' + row.id).then((res) => {
          this.QRCodePath = res.data.data;
          this.visible2 = true;
          console.log('this.QRCodePath', this.QRCodePath);
        });
      } else if (type == 4) {
        let obj = {
          query: this.query.query,

          examSite: this.query.examSite, //考点id
          provinceId: this.query.provinceId, //全部省份
        };
        this.exportTicketLoading = true;

        this.$axios
          .post('assigns/export/code', obj, { responseType: 'blob' })
          .then((res) => {
            exportFile(res);
            this.exportTicketLoading = false;
          })
          .catch((err) => {
            this.exportTicketLoading = false;
          });

        // this.$axios
        //   .get("assigns/export/code", {
        //     responseType: "blob",
        //   })
        //   .then((res) => {
        //     exportFile(res);
        //   });
      }
    },
    submit() {
      let {
        examSiteId,
        // region,
        registrationAddress,
        registrationPoint,
        registrationPointName,
        id,
      } = this.visibleObj;
      if (
        examSiteId == '' ||
        registrationAddress == '' ||
        registrationPoint == '' ||
        registrationPointName == ''
        // ||(this.divisionList.length != 0 && region == '')
      ) {
        this.$message({
          type: 'warning',
          message: '必填项不能为空!',
          duration: 1000,
        });
        return;
      }
      let subType = this.visibleType === 1 ? 'post' : 'put';
      let url = this.visibleType === 1 ? '/assigns' : '/assigns/' + id;
      this.$axios({
        method: subType,
        url: url,
        data: this.visibleObj,
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '保存成功!',
          duration: 1000,
        });
        this.visible = false;
        this.tableLoad();
      });
    },
    submit1() {
      let { userName, name, mobile } = this.visibleObj1;
      let numberTest = /^\d{10,15}$/;
      if (userName === '' || name === '' || mobile === '') {
        this.$message({
          type: 'warning',
          message: '必填项不能为空!',
          duration: 1000,
        });
        return;
      }
      if (!numberTest.test(mobile)) {
        this.$message({
          type: 'warning',
          message: '请输入10-15位数字的手机号！',
          duration: 1000,
        });
        return;
      }
      this.$axios({
        method: 'post',
        url: '/assigns/adduser',
        data: {
          ...this.visibleObj1,
          idNumber: this.visibleObj1.idNumber == '' ? null : this.visibleObj1.idNumber,
        },
      }).then((res) => {
        console.log('res',res)
        if (res.data.code == 10000) {
          this.$message({
            type: 'success',
            message: '添加成功!',
            duration: 1000,
          });
          this.visible1 = false;
          this.tableLoad();
        } else {
          this.visible1 = false;
          this.$message({
            type: 'error',
            message: res.message ? res.message : '添加失败!',
            duration: 1000,
          });
        }
      });
    },
    getDivisionList(val) {
      let examination = this.examinationList.find((item) => {
        return item.id === val;
      });
      this.divisionList = examination.divisionList;
      // this.visibleObj.region = '';
    },
    handleSelectionChange(val) {
      this.tableSelectList = val;
    },
    handleInput() {
      this.visibleObj.registrationPointName = this.visibleObj.registrationPointName
        .replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')
        .slice(0, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.registrationManagement {
  .tableHearInputBox {
    .el-dropdown {
      margin: 0px 10px;
    }

    .el-select {
      width: 140px;
      margin-left: 10px !important;
    }
  }
}

.tip {
  color: rgb(240, 10, 10);
  margin: 16px auto;
}
</style>
